// Tag.tsx
import React from "react";

interface TagProps {
  label: string;
}

const Tag: React.FC<TagProps> = ({ label }) => {
  // Container classes
  const containerClasses = [
    "h-7",
    "px-2",
    "bg-[#ebebe5]",
    "rounded-sm",
    "justify-center",
    "items-center",
    "gap-2.5",
    "inline-flex",
  ].join(" ");

  // Label classes
  const labelClasses = [
    "text-[#04262b]",
    "text-sm",
    "font-semibold",
    "font-['Manrope']",
    "leading-tight",
    "tracking-tight",
  ].join(" ");

  return (
    <div className={containerClasses}>
      <span className={labelClasses}>{label}</span>
    </div>
  );
};

export default Tag;
